export const PRODUCT_LIST = "PRODUCT_LIST";
export const GET_PRODUCT_INPUT = "GET_PRODUCT_INPUT";
export const IS_CREATE_PRODUCT = "IS_CREATE_PRODUCT";
export const AFTER_CREATE_PRODUCT = "AFTER_CREATE_PRODUCT";
export const PRE_UPDATE_PRODUCT = "PRE_UPDATE_PRODUCT";
export const AFTER_UPDATE_PRODUCT = "AFTER_UPDATE_PRODUCT";
export const IS_PRODUCT_LIST_LOADING = "IS_PRODUCT_LIST_LOADING";
export const ICON_LOADING = "ICON_LOADING";
export const IMG_LOADING = "IMG_LOADING";
